import { render, staticRenderFns } from "./login-menu.vue?vue&type=template&id=afc13680&scoped=true"
import script from "./login-menu.vue?vue&type=script&lang=js"
export * from "./login-menu.vue?vue&type=script&lang=js"
import style0 from "./login-menu.vue?vue&type=style&index=0&id=afc13680&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc13680",
  null
  
)

export default component.exports